import { render, staticRenderFns } from "./PrincipleItem.vue?vue&type=template&id=f7be19d2&scoped=true&"
import script from "./PrincipleItem.vue?vue&type=script&lang=js&"
export * from "./PrincipleItem.vue?vue&type=script&lang=js&"
import style0 from "./PrincipleItem.vue?vue&type=style&index=0&id=f7be19d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7be19d2",
  null
  
)

export default component.exports